import * as React from 'react';
import Button from '@material-ui/core/Button';
import { compose, defaultProps, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { Loader } from '@topconagriculture/loader';
const styles = (theme) => createStyles({
    actionButton: {
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.bold,
        minWidth: 95,
        height: 40,
        '&:hover': {
            background: 'transparent',
        },
    },
});
const ModalActionButton = (props) => {
    const { classes, btnLabel, action, isLoading, testId = 'ModalActionButton', disabled, title } = props;
    return (React.createElement(Button, { "data-testid": testId, onClick: action, disabled: disabled, className: classes.actionButton, title: title }, isLoading ? React.createElement(Loader, { size: 20 }) : btnLabel || ''));
};
const ComposedModalButton = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    action: null,
    disabled: false,
}))(ModalActionButton);
ComposedModalButton.displayName = 'ModalButton';
export default ComposedModalButton;
//# sourceMappingURL=ModalActionButton.js.map